import ExceptionIssue from '../../../model/ExceptionIssue'
import UnhandledException from '../../../model/UnhandledException'
import { exceptionApi } from '../../../rest-api/Exception-api'
import { Dispatch } from 'redux'
import { actionCreatorFactory, AnyAction } from 'typescript-fsa'
import wrapAsyncWorker from '../../../common/wrapAsyncWorker'

const actionCreator = actionCreatorFactory()

export const RaiseException = actionCreator.async<
  UnhandledException,
  ExceptionIssue,
  { message: string }
>('RaiseException')

const raiseExceptionWorker = wrapAsyncWorker(
  RaiseException,
  (unhandled): Promise<ExceptionIssue> => exceptionApi.raiseException(unhandled)
)

// thunk action creator
export const raiseException = (unhandled: UnhandledException) => {
  return (dispatch: Dispatch<AnyAction>) => raiseExceptionWorker(dispatch, unhandled)
}

export const ClearException = actionCreator('ClearException')
